module.exports = __webpack_public_path__ + "static/media/Picker_niveau2_elN0_4_1296709412.c7ca9880.png";